const carouselData = [
  {
    background: '#E91E63',
    title: 'Feature',
    desc: 'Vestibulum tempor, sem et molestie egestas, dui tortor laoreet tellus.',
    icon: 'flag',
  },
  {
    background: '#0091EA',
    title: 'Unlimited',
    desc: 'Aliquam nec ex aliquet, aliquam neque non, gravida est.',
    icon: 'all_inclusive',
  },
  {
    background: '#00BFA5',
    title: 'Complete',
    desc: 'Vestibulum bibendum nisi eget magna malesuada',
    icon: 'done',
  },
  {
    background: '#F57F17',
    title: 'Easy',
    desc: 'Vestibulum tempor, sem et molestie egestas, dui tortor laoreet tellus.',
    icon: 'extension',
  },
  {
    background: '#7CB342',
    title: 'Satisfy',
    desc: 'Aliquam nec ex aliquet, aliquam neque non, gravida est.',
    icon: 'mood',
  },
  {
    background: '#546E7A',
    title: 'Public',
    desc: 'Quisque a consequat ante, at volutpat enim. Aenean sit amet magna vel magna',
    icon: 'public',
  },
  {
    background: '#00ACC1',
    title: 'Awesome',
    desc: 'Vestibulum tempor, sem et molestie egestas, dui tortor laoreet tellus.',
    icon: 'thumb_up',
  },
  {
    background: '#C51162',
    title: 'Safeguard',
    desc: 'Quisque a consequat ante, at volutpat enim. Aenean sit amet magna vel magna',
    icon: 'lock',
  },
  {
    background: '#7C4DFF',
    title: 'Favorite',
    desc: ' Aenean facilisis vitae purus facilisis semper.',
    icon: 'favorite',
  },
];

export default carouselData;
